import { PropsWithChildren } from "react"

import { Container } from "ui-kit/components-branded/index"
import style from "modules/HRAccount/Layout/layout.module.scss"

export function Layout({ children }: PropsWithChildren<unknown>) {
    return <Container className={style.container}>{children}</Container>
}
